export const duosCoalitionMock = {
  "platformName": "Governor",
  "coalitionType": "governor delegate",
  "data": [
      {
          "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
          "type": "governor delegate",
          "membersInCoalition": 2,
          "members": [
              {
                  "address": "0x5a5d9ab7b1bd978f80909503ebb828879daca9c3",
                  "name": "cerv1.eth",
                  "avatar": null
              },
              {
                  "address": "0xc2e2b715d9e302947ec7e312fd2384b5a1296099",
                  "name": "kbw.eth",
                  "avatar": null
              }
          ],
          "delegatorsNumber": 269,
          "votedTogether": 4,
          "votingPower": 885086.7952586345,
          "votingPowerPercentage": 14.503513848941331,
          "votingPowerCirculatingSupplyPercentage": 0.9182853096459842,
          "votingPowerNeededForWinningPercentage": 1.8365705811828068,
          "votingPower6MonthWinningPercentage": 62.8794874958129
      },
      {
          "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
          "type": "governor delegate",
          "membersInCoalition": 2,
          "members": [
              {
                  "address": "0x5a5d9ab7b1bd978f80909503ebb828879daca9c3",
                  "name": "cerv1.eth",
                  "avatar": null
              },
              {
                  "address": "0x839395e20bbb182fa440d08f850e6c7a8f6f0780",
                  "name": "Griff Green",
                  "avatar": "eip155:1/erc721:0xf5918382dd20ecba89747c50f80fb7f9f1e0524c/691"
              }
          ],
          "delegatorsNumber": 307,
          "votedTogether": 3,
          "votingPower": 420773.53772187565,
          "votingPowerPercentage": 6.895024153912464,
          "votingPowerCirculatingSupplyPercentage": 0.43655623431243296,
          "votingPowerNeededForWinningPercentage": 0.8731124505076294,
          "votingPower6MonthWinningPercentage": 29.89314104050128
      },
      {
          "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
          "type": "governor delegate",
          "membersInCoalition": 2,
          "members": [
              {
                  "address": "0x5a5d9ab7b1bd978f80909503ebb828879daca9c3",
                  "name": "cerv1.eth",
                  "avatar": null
              },
              {
                  "address": "0xabf28f8d9adfb2255f4a059e37d3bce9104969db",
                  "name": "meglister.eth",
                  "avatar": null
              }
          ],
          "delegatorsNumber": 85,
          "votedTogether": 3,
          "votingPower": 400522.9956118584,
          "votingPowerPercentage": 6.563187751522819,
          "votingPowerCirculatingSupplyPercentage": 0.4155461193365764,
          "votingPowerNeededForWinningPercentage": 0.8310922214278436,
          "votingPower6MonthWinningPercentage": 28.454475684502857
      },
      {
          "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
          "type": "governor delegate",
          "membersInCoalition": 2,
          "members": [
              {
                  "address": "0x839395e20bbb182fa440d08f850e6c7a8f6f0780",
                  "name": "Griff Green",
                  "avatar": "eip155:1/erc721:0xf5918382dd20ecba89747c50f80fb7f9f1e0524c/691"
              },
              {
                  "address": "0xc2e2b715d9e302947ec7e312fd2384b5a1296099",
                  "name": "kbw.eth",
                  "avatar": null
              }
          ],
          "delegatorsNumber": 497,
          "votedTogether": 2,
          "votingPower": 505018.8538060807,
          "votingPowerPercentage": 8.275513745533436,
          "votingPowerCirculatingSupplyPercentage": 0.523961488329359,
          "votingPowerNeededForWinningPercentage": 1.047922954914133,
          "votingPower6MonthWinningPercentage": 35.878206378358485
      },
      {
          "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
          "type": "governor delegate",
          "membersInCoalition": 2,
          "members": [
              {
                  "address": "0x839395e20bbb182fa440d08f850e6c7a8f6f0780",
                  "name": "Griff Green",
                  "avatar": "eip155:1/erc721:0xf5918382dd20ecba89747c50f80fb7f9f1e0524c/691"
              },
              {
                  "address": "0xabf28f8d9adfb2255f4a059e37d3bce9104969db",
                  "name": "meglister.eth",
                  "avatar": null
              }
          ],
          "delegatorsNumber": 312,
          "votedTogether": 2,
          "votingPower": 20455.05415930458,
          "votingPowerPercentage": 0.3351876481149262,
          "votingPowerCirculatingSupplyPercentage": 0.021222298019951322,
          "votingPowerNeededForWinningPercentage": 0.04244459515916985,
          "votingPower6MonthWinningPercentage": 1.453194567048446
      },
      {
          "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
          "type": "governor delegate",
          "membersInCoalition": 2,
          "members": [
              {
                  "address": "0xabf28f8d9adfb2255f4a059e37d3bce9104969db",
                  "name": "meglister.eth",
                  "avatar": null
              },
              {
                  "address": "0xc2e2b715d9e302947ec7e312fd2384b5a1296099",
                  "name": "kbw.eth",
                  "avatar": null
              }
          ],
          "delegatorsNumber": 276,
          "votedTogether": 2,
          "votingPower": 484768.31169606344,
          "votingPowerPercentage": 7.943677343143793,
          "votingPowerCirculatingSupplyPercentage": 0.5029513733535026,
          "votingPowerNeededForWinningPercentage": 1.0059027258343471,
          "votingPower6MonthWinningPercentage": 34.43954102236007
      }
  ]
};

export const triosColitionMock = {
  "platformName": "Governor",
  "coalitionType": "governor delegate",
  "data": [
      {
          "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
          "type": "governor delegate",
          "membersInCoalition": 3,
          "members": [
              {
                  "address": "0x5a5d9ab7b1bd978f80909503ebb828879daca9c3",
                  "name": "cerv1.eth",
                  "avatar": null
              },
              {
                  "address": "0x839395e20bbb182fa440d08f850e6c7a8f6f0780",
                  "name": "Griff Green",
                  "avatar": "eip155:1/erc721:0xf5918382dd20ecba89747c50f80fb7f9f1e0524c/691"
              },
              {
                  "address": "0xc2e2b715d9e302947ec7e312fd2384b5a1296099",
                  "name": "kbw.eth",
                  "avatar": null
              }
          ],
          "delegatorsNumber": 536,
          "votedTogether": 3,
          "votingPower": 905439.5933932954,
          "votingPowerPercentage": 14.837025874193616,
          "votingPowerCirculatingSupplyPercentage": 0.939401516143888,
          "votingPowerNeededForWinningPercentage": 1.8788029933022845,
          "votingPower6MonthWinningPercentage": 64.32541745733633
      },
      {
          "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
          "type": "governor delegate",
          "membersInCoalition": 3,
          "members": [
              {
                  "address": "0x5a5d9ab7b1bd978f80909503ebb828879daca9c3",
                  "name": "cerv1.eth",
                  "avatar": null
              },
              {
                  "address": "0x839395e20bbb182fa440d08f850e6c7a8f6f0780",
                  "name": "Griff Green",
                  "avatar": "eip155:1/erc721:0xf5918382dd20ecba89747c50f80fb7f9f1e0524c/691"
              },
              {
                  "address": "0xabf28f8d9adfb2255f4a059e37d3bce9104969db",
                  "name": "meglister.eth",
                  "avatar": null
              }
          ],
          "delegatorsNumber": 351,
          "votedTogether": 3,
          "votingPower": 420875.7937465193,
          "votingPowerPercentage": 6.8966997767751055,
          "votingPowerCirculatingSupplyPercentage": 0.43666232583448034,
          "votingPowerNeededForWinningPercentage": 0.8733246335473214,
          "votingPower6MonthWinningPercentage": 29.90040564602629
      },
      {
          "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
          "type": "governor delegate",
          "membersInCoalition": 3,
          "members": [
              {
                  "address": "0x5a5d9ab7b1bd978f80909503ebb828879daca9c3",
                  "name": "cerv1.eth",
                  "avatar": null
              },
              {
                  "address": "0xabf28f8d9adfb2255f4a059e37d3bce9104969db",
                  "name": "meglister.eth",
                  "avatar": null
              },
              {
                  "address": "0xc2e2b715d9e302947ec7e312fd2384b5a1296099",
                  "name": "kbw.eth",
                  "avatar": null
              }
          ],
          "delegatorsNumber": 314,
          "votedTogether": 3,
          "votingPower": 885189.0512832782,
          "votingPowerPercentage": 14.505189471803972,
          "votingPowerCirculatingSupplyPercentage": 0.9183914011680315,
          "votingPowerNeededForWinningPercentage": 1.8367827642224988,
          "votingPower6MonthWinningPercentage": 62.88675210133791
      },
      {
          "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
          "type": "governor delegate",
          "membersInCoalition": 3,
          "members": [
              {
                  "address": "0x839395e20bbb182fa440d08f850e6c7a8f6f0780",
                  "name": "Griff Green",
                  "avatar": "eip155:1/erc721:0xf5918382dd20ecba89747c50f80fb7f9f1e0524c/691"
              },
              {
                  "address": "0xabf28f8d9adfb2255f4a059e37d3bce9104969db",
                  "name": "meglister.eth",
                  "avatar": null
              },
              {
                  "address": "0xc2e2b715d9e302947ec7e312fd2384b5a1296099",
                  "name": "kbw.eth",
                  "avatar": null
              }
          ],
          "delegatorsNumber": 542,
          "votedTogether": 2,
          "votingPower": 505121.10983072437,
          "votingPowerPercentage": 8.277189368396078,
          "votingPowerCirculatingSupplyPercentage": 0.5240675798514065,
          "votingPowerNeededForWinningPercentage": 1.048135137953825,
          "votingPower6MonthWinningPercentage": 35.8854709838835
      }
  ]
};

export const foursCoalitionMock = {
  "platformName": "Governor",
  "coalitionType": "governor delegate",
  "data": [
      {
          "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
          "type": "governor delegate",
          "membersInCoalition": 4,
          "members": [
              {
                  "address": "0x5a5d9ab7b1bd978f80909503ebb828879daca9c3",
                  "name": "cerv1.eth",
                  "avatar": null
              },
              {
                  "address": "0x839395e20bbb182fa440d08f850e6c7a8f6f0780",
                  "name": "Griff Green",
                  "avatar": "eip155:1/erc721:0xf5918382dd20ecba89747c50f80fb7f9f1e0524c/691"
              },
              {
                  "address": "0xabf28f8d9adfb2255f4a059e37d3bce9104969db",
                  "name": "meglister.eth",
                  "avatar": null
              },
              {
                  "address": "0xc2e2b715d9e302947ec7e312fd2384b5a1296099",
                  "name": "kbw.eth",
                  "avatar": null
              }
          ],
          "delegatorsNumber": 580,
          "votedTogether": 3,
          "votingPower": 905541.8494179391,
          "votingPowerPercentage": 14.838701497056256,
          "votingPowerCirculatingSupplyPercentage": 0.9395076076659354,
          "votingPowerNeededForWinningPercentage": 1.8790151763419765,
          "votingPower6MonthWinningPercentage": 64.33268206286134
      }
  ]
};
